import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import CreateClaimExternal from "../Claim/CreateClaimExternal";
import PropTypes from "prop-types";
import React from "react";

const YourPhoneNumber = props => {
    return <PlaceholderWrapper placeholderId="20"
                               title={<><i
                                   className="fa fa-phone-volume"/> {i18next.t("Your_phone_number_1", {phone: props.phone})}
                                   <CreateClaimExternal style={{marginLeft: "10px"}}
                                                        claimMenuId="CMD_LK_CREATE_CHANGE_PHONE"/>
                               </>}
                               staticTitle={i18next.t("Your_phone_number_1")}
                               showSplitterLine={true} canCollapse={true}>
    </PlaceholderWrapper>;
};

YourPhoneNumber.propTypes = {
    phone: PropTypes.any
};

export default YourPhoneNumber;